import { 
    ContainerImage,
    ContainerImageBottom,
    HeroSection,
    ProductSection,
    ProductsTitleSection, 
    StorySector
} from "./sections"
import { TickerAnimation } from "./sections/heroSection/componets/tickerAnimation"





export const MainPage=()=>{
    const border='1px solid black'
    
    return(
        <>
            <HeroSection/>
            <ProductsTitleSection/>
            <ProductSection/>
            <div  className="__container">
                <div style={{
                    borderRight:border,
                    borderLeft:border
                }}>
                    <TickerAnimation/>
                </div>
            </div>
            <ContainerImage pathName={'IMAGE-mainPage-container-image.jpg'}/>
            <StorySector/>
            <div  className="__container">
                <div style={{
                    borderRight:border,
                    borderLeft:border
                }}>
                    <TickerAnimation/>
                </div>
            </div>
            <ContainerImageBottom  pathName={'Frame-bg-fire-image.png'}/>
        </>
    )
}